<template>
  <div id="app">
    <iframe
      style="border: none"
      :width="searchTableWidth"
      :height="searchTableHeight"
      v-bind:src="reportUrl"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reportUrl: "https://www.xuexi.cn/xxqg.html?id=e433dab0149a4d42bb914b7a296ea7ff#6a02",
      searchTableHeight:'100%',
      searchTableWidth: '100%',
    };
  },
  created() {
    // 从路由里动态获取 url地址   具体地址看libs下util.js里的 backendMenuToRoute  方法
    this.reportUrl = "https://www.xuexi.cn/xxqg.html?id=e433dab0149a4d42bb914b7a296ea7ff#6a02";
  },
  mounted() {
    // window.onresize = () => {
    //   this.widthHeight(); // 自适应高宽度
    // };
    // this.$nextTick(function () {
    //   this.widthHeight();
    // });
  },
  methods: {
    // widthHeight() {
    //   this.searchTableHeight = window.innerHeight - 180;
    // //   this.searchTableWidth = window.innerWidth - 230;
    // },
  },
  watch: {
    $route: function () {
      // 监听路由变化
      this.reportUrl = "https://www.xuexi.cn/xxqg.html?id=e433dab0149a4d42bb914b7a296ea7ff#6a02";
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/outerChain.vue